export default "__VITE_ASSET__bFyXhfMh__"